import { useState, useCallback } from "react";
import type { SupplierUserSimpleListItem } from "@/types/apis";

// ==================== Hook实现 ====================
/**
 * 管理供应商选择弹框状态和数据
 */
export const useSupplierSelectModal = () => {
  const [modalOpen, setModalOpen] = useState(false);
  const [selectedSupplier, setSelectedSupplier] =
    useState<SupplierUserSimpleListItem | null>(null);

  const handleOpenModal = useCallback(() => {
    setModalOpen(true);
  }, []);

  const handleCloseModal = useCallback(
    (pickedSupplier?: SupplierUserSimpleListItem) => {
      if (pickedSupplier) {
        setSelectedSupplier(pickedSupplier);
      }
      setModalOpen(false);
    },
    [],
  );

  return {
    modalOpen,
    selectedSupplier,
    handleOpenModal,
    handleCloseModal,
  };
};
